import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import styled from 'styled-components';
import { Loader } from '../../loaders/loader';
import { TableBodyWrapper, TableWrapper } from '../../table/styles';
import { recommendedTableColumns } from '../constants';
import { IInvestorInterestList, TypeWindow } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface RecommendedTableProps {
  openPage: (id: string, type: TypeWindow) => void;
  loading: boolean;
  recommendedData: IInvestorInterestList[];
  refetch: () => void;
  sort: ISort;
  setSort: (value: ISort) => void;
}

const RecommendedTable = ({ openPage, loading, recommendedData, refetch, sort, setSort }: RecommendedTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>{loading ? <CustomLoader /> : <MobileTable recommendedData={recommendedData} openPage={openPage} />}</>
      ) : (
        <>
          <TableHeader refetch={() => null as any} columns={recommendedTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>{loading ? <CustomLoader /> : <TableBody recommendedData={recommendedData} openPage={openPage} />}</TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default RecommendedTable;

const CustomLoader = styled(Loader)`
  height: 50vh;
`;
